import { Post, Get, downFilePost } from '@/utils/axios'
/**
  POST
  添加购物车
 */
export function addShoppingCart(data) {
  return Post('/Order/AddShoppingCart', data)
}

/**
 * 购物车列表
 * @param data {{pageNum: number, pageSize: number,   "totalNum": number, "sort": "string", "sortType": "string"} }
 * @returns
 */
export function GetMyShoppingCartList(data) {
  return Post('/Order/GetMyShoppingCartList', data)
}

/**
 * 修改购物车
 * @param {{id: number, nums: number}} data

 * @returns
 */
export function ModifyShoppingCartNum(data) {
  return Post('/Order/ModifyShoppingCartNum', data)
}
/**
 * 删除购物车
 * @param {*} id 购物车数据id
 * @returns
 */
export function DeleteShoppingCart(id) {
  return Post('/Order/DeleteShoppingCart', { id })
}

/**
 * 创建订单
 * @param {*} data
 * @returns
 */
export function OrderCreate(data) {
  return Post('/Order/Create', data)
}

/**
 * 直接发货订单创建
 * @param {*} data
 * @returns
 */
export function DropshippingOrderCreate(data) {
  return Post('/Order/DropshippingOrders/Create', data)
}

/**
 * 订单统计
 * @param {*} data
 */
export function GetOrderStatusStatistics(data) {
  return Post('/Order/GetOrderStatusStatistics', data)
}

/**
 * 左侧导航菜单订单数量标记
 * @param {*} data
 */
export function GetLeftMenuOrderTotalCount() {
  return Get('/Order/GetLeftMenuOrderTotalCount')
}

/**
 * 订单列表
 * @param {*} data
 */
export function getOrderList(data) {
  return Post('/Order/GetOrderList', data)
}

/**
 * 备库订单列表
 * @param {*} data
 * @returns
 */
export function getStockOrderListApp(data) {
  return Post('/Order/GetStockOrderListApp', data)
}

/**
 * 订单详情
 * @param {*} data  { "id": 0, "data": "string" }
 * @returns
 */
export function getOrderInfo(id) {
  return Post(`/Order/GetOrderInfo`, { id })
}

/**
 * POST
/app/Order/GetOrderInfoList
获取app端的订单详情
 */
export function getOrderInfoList(data) {
  return Post(`/Order/GetOrderInfoList`, data)
}
/**
 * POST
/app/Order/GetOrdersInfo
获取app端的订单列表（二次发货）
 */
export function GetOrdersInfo(data) {
  return Post(`/Order/GetOrdersInfo`, data)
}

/**
 * 取消订单
 * @param {*} id
 * @returns
 */
export function CancelOrder(id) {
  return Post('/Order/CancelOrder', { id })
}

/**
 * POST
/app/Order/BatchCancelOrder
批量取消订单
 */
export function batchCancelOrder(data) {
  return Post('/Order/BatchCancelOrder',data)
}

/**
 * 取消恢复
 * @param {*} id
 * @returns
 */
export function RestoreCancelOrder(id) {
  return Post('/Order/RestoreCancelOrder', { id })
}

/**
 * 单条支付
 * @param {*} ids
 * @returns
 */
export function OrderPay(data) {
  return Post('/Order/OrderPay', data)
}

/**
 * 批量支付
 * @param {*} ids
 * @returns
 */
export function BatchOrderPay(ids) {
  return Post('/Order/BatchOrderPay', { ids })
}

/**
 * 订单运输方式列表
 * @param {*} data
 * @returns
 */
export function GetOrderTransportType(data) {
  return Post('/Order/GetOrderTransportType', data)
}

/**
 * 选择物流方式
 * @param {*} data
 * @returns
 */
export function SelectTransportType(data) {
  return Post('/Order/SelectTransportType', data)
}

/**
 * 询价
 * @param {*} data
 * @returns
 */
export function OrderItemInquiryPrice(data) {
  return Post('/Order/OrderItemInquiryPrice', data)
}

/**
 * 退款
 * @param {*} data
 * @returns
 */
export function ApplyRefund(data) {
  return Post('/Order/ApplyRefund', data)
}

/**
 * 拆分订单
 * @param {*} data
 * @returns
 */
export function SplitOrder(data) {
  return Post('/Order/SplitOrder', data)
}

/**
 * 合并接口 在restore中用
 * @param {*} id
 * @returns
 */
export function MergeOrderApp(id) {
  return Post('/Order/MergeOrderApp', { id })
}

export function UpdateOrderAddress(data) {
  return Post('Order/UpdateOrderAddress', data)
}

/*
  订单添加商品
*/
export function AddProductToOrder(data) {
  return Post('/Order/AddProductToOrder', data)
}

/*
  可合并订单列表
*/
export function getOrderMergeList(data) {
  return Post('/Order/GetOrderMergeList', data)
}

/*
  可合并订单(跨订单合并)
*/
export function orderMerge(data) {
  return Post('/Order/OrderMerge', data)
}

/**
 * 获取订单运输方式
 * @param {*} data
 * @returns
 */
export function getTransportType(data) {
  return Post('/Goods/GetTransportType', data)
}

/**
 * 获取二次发货信息
 * @param {*} id
 * @returns
 */
export function getSecondaryShipment(id) {
  return Get(`/Order/GetOrderSecondaryShipmentList/id`, { id })
}

/**
 * 修改二次发货地址
 * @param {*} data
 * @returns
 */
export function updateOrderSecondaryShipmentAddress(data) {
  return Post(`/Order/UpdateOrderSecondaryShipmentAddress`, data)
}

/**
 * 二次发货需要的支付信息
 * @param {*} data
 * @returns
 */
export function getSecondaryShipmentPayInfo(data) {
  return Post(`/Order/GetSecondaryShipmentPayInfo`, data)
}

/**
 * 二次发货支付
 * @param {*} data
 * @returns
 */
export function secondaryShipmentPay(data) {
  return Post('/Order/SecondaryShipmentPay', data)
}

/**
 * 异常解决
 * @param {*} data
 * @returns
 */
export function solvedAbnormal(data) {
  return Post('/Order/SolvedAbnormal', data)
}

/**
 * 订单搁置
 * @param {*} data
 * @returns
 */
export function orderShelve(data) {
  return Post('/Order/OrderShelve', data)
}
/**
 * 订单二次发货用户确认
 * @param {*} data
 * @returns
 */
export function OrderReissuePayStatusUserConfirm(data) {
  return Post('/Order/OrderReissuePayStatusUserConfirm', data)
}
export function GetOrderSecondaryShipmentStatistics(data) {
  return Post('/Order/GetOrderSecondaryShipmentStatistics', data)
}
export function GetOrderPaidStatistics(data) {
  return Post('/Order/GetOrderPaidStatistics', data)
}
// 获取订单的服务信息
export function GetOrderServices(id) {
  return Get(`/Order/GetOrderServices/${id}`)
}
// 批量拆分订单
export function BatchSplitOrder(data) {
  return Post('/Order/BatchSplitOrder', data)
}
// 批量给订单增加商品
export function AddProductsToBatchOrder(data) {
  return Post('/Order/AddProductsToBatchOrder', data)
}
// 补充支付
export function ReplenisAmountPay(data) {
  return Post('/Order/WholesaleOrder/ReplenisAmountPay', data)
}
// 询价
export function WholesaleOrderAskForQuote(data) {
  return Post('/Order/WholesaleOrderAskForQuote', data)
}
// 批量订单列表
export function GetWholesaleOrders(data) {
  return Post('/Order/GetWholesaleOrders', data)
}

export function ExportOrder(data) {
  return downFilePost('/Order/ExportOrder', data)
}

// // 修改地址
// export function UpdateOrderAddress(data) {
//   return Post('/Order/UpdateOrderAddress', data)
// }